module.exports = __webpack_public_path__ + "static/media/1022726.a5fcc7dc.jpg";